import React from "react";
import "../styles/legal.css";
import { useTranslation, Trans } from "react-i18next"; // 1. Import

const TermsAndConditions = () => {
  const { t } = useTranslation(); // 2. Initialize t

  // Helper to render list items
  const renderListItems = (baseKey) => {
    const items = t(baseKey, { returnObjects: true });
    if (!Array.isArray(items)) {
      console.warn(`Translation for ${baseKey} is not an array or is missing.`);
      return null;
    }
    return items.map((item, index) => <li key={index}>{item}</li>);
  };

  return (
    <div className="legal-container">
      <header className="legal-header">
        <h1>{t("termsAndConditions.header.title")}</h1>
        <p>{t("termsAndConditions.header.effectiveDate")}</p>
      </header>

      <section className="legal-section">
        <h2>{t("termsAndConditions.acceptance.title")}</h2>
        <p>{t("termsAndConditions.acceptance.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("termsAndConditions.purpose.title")}</h2>
        <p>{t("termsAndConditions.purpose.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("termsAndConditions.useOfWebsite.title")}</h2>
        <p>{t("termsAndConditions.useOfWebsite.mainContent")}</p>
        <h3>{t("termsAndConditions.useOfWebsite.prohibitedUses.title")}</h3>
        <p>{t("termsAndConditions.useOfWebsite.prohibitedUses.intro")}</p>
        <ul>
          {renderListItems(
            "termsAndConditions.useOfWebsite.prohibitedUses.list"
          )}
        </ul>
      </section>

      <section className="legal-section">
        <h2>{t("termsAndConditions.intellectualProperty.title")}</h2>
        <p>{t("termsAndConditions.intellectualProperty.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("termsAndConditions.projectInfoDisclaimer.title")}</h2>
        <p>{t("termsAndConditions.projectInfoDisclaimer.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("termsAndConditions.externalLinks.title")}</h2>
        <p>{t("termsAndConditions.externalLinks.content")}</p>
      </section>

      <section className="legal-section">
        <h2>{t("termsAndConditions.limitationOfLiability.title")}</h2>
        <p>{t("termsAndConditions.limitationOfLiability.content")}</p>
      </section>

      <footer className="legal-footer">
        <p>
          <Trans i18nKey="termsAndConditions.footer.contact">
            For any legal concerns, please contact us at{" "}
            <a href="mailto:info@e-qera.com">info@e-qera.com</a>
          </Trans>
        </p>
        <p>
          {t("termsAndConditions.footer.copyright", {
            year: new Date().getFullYear(),
          })}
        </p>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
